import { useCallback, useEffect, useRef, useState } from 'react'

import { ControlsVisibilityOptions } from './useControlsVisibility.types'

export const useControlsVisibility = ({
  autoHide,
  delay,
  enabled,
  isLocked,
  isPlaying
}: ControlsVisibilityOptions) => {
  const timerRef = useRef<number | null>(null)
  const [areControlsVisible, setAreControlsVisible] = useState(true)

  const clearHideTimer = useCallback(() => {
    if (timerRef.current === null) return
    window.clearTimeout(timerRef.current)
    timerRef.current = null
  }, [])

  const scheduleHide = useCallback(() => {
    clearHideTimer()
    if (!isPlaying || !autoHide || !enabled || isLocked) return

    timerRef.current = window.setTimeout(
      () => setAreControlsVisible(false),
      delay
    )
  }, [autoHide, clearHideTimer, delay, enabled, isLocked, isPlaying])

  const revealControls = useCallback(() => {
    setAreControlsVisible(true)
    scheduleHide()
  }, [scheduleHide])

  const keepControlsVisible = useCallback(() => {
    clearHideTimer()
    setAreControlsVisible(true)
  }, [clearHideTimer])

  useEffect(() => {
    setAreControlsVisible(true)
    scheduleHide()
    return clearHideTimer
  }, [clearHideTimer, scheduleHide])

  return {
    areControlsVisible,
    keepControlsVisible,
    revealControls
  }
}
